var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},[_c('div',{staticClass:"progress-bar"},[_c('label',{staticClass:"white--text"},[_vm._v("Onboarding Progress: "),_c('span',[_vm._v(" "+_vm._s(_vm.value)+"%")])]),_c('div',{staticClass:"pt-1"},[_c('v-progress-linear',{attrs:{"value":_vm.value,"color":_vm.color,"background-color":_vm.bgColor,"rounded":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }